import Grid from '@mui/material/Grid2'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import { useFilesStore } from '../../../../store/storeFiles'
import { FileCardList } from './FileCardList'
import { FileTableList } from './FileTableList'
import { FileUploaderButton } from './FileUploaderButton'

export const Files = ({ viewFileList, isRequestPage, isReadOnly = true, handleClick }) => {
    const { filesUser, isLoadingFetchFilesUser } = useFilesStore((state) => state)
    const params = useParams()

    return (
        <>
            {isLoadingFetchFilesUser && (
                <Grid
                    size={{ xs: 12, sm: 12, md: 6, lg: 3 }}
                    sx={{ display: 'flex', width: '100% !important' }}>
                    <Skeleton
                        variant="rectangular"
                        sx={{
                            height: '192px',
                            width: '270px',
                            borderRadius: '24px',
                            mb: '4px',
                            mr: 2,
                        }}
                    />
                    <Skeleton
                        variant="rectangular"
                        sx={{
                            height: '192px',
                            width: '270px',
                            borderRadius: '24px',
                            mb: '4px',
                            mr: 2,
                        }}
                    />
                    <Skeleton
                        variant="rectangular"
                        sx={{
                            height: '192px',
                            width: '270px',
                            borderRadius: '24px',
                            mb: '4px',
                            mr: 2,
                        }}
                    />
                    <Skeleton
                        variant="rectangular"
                        sx={{
                            height: '192px',
                            width: '270px',
                            borderRadius: '24px',
                            mb: '4px',
                            mr: 2,
                        }}
                    />
                </Grid>
            )}
            {!isReadOnly && filesUser?.length === 0 && (
                <Grid size={12} sx={{ textAlign: 'center', mt: 10 }}>
                    <Typography variant="h5" sx={{ color: '#181B25' }}>
                        У вас нет добавленных ресурсов
                    </Typography>
                    <Typography
                        variant="caption2"
                        sx={{
                            color: '#5A5F72',
                            maxWidth: '252px',
                            mt: 2,
                            mb: 2,
                        }}>
                        Добавьте документы, изображения и ссылки — они будут включены в контекст
                        {isRequestPage ? ' запроса' : ' проекта'} для использования ассистентом
                    </Typography>
                    <Grid sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <FileUploaderButton
                            idEntity={isRequestPage ? params.requestId : params.projectId}
                        />
                    </Grid>
                </Grid>
            )}

            {filesUser?.length > 0 && viewFileList === 'card' && (
                <FileCardList
                    handleClick={handleClick}
                    isReadOnly={isReadOnly}
                    files={filesUser}
                    idEntity={isRequestPage ? params.requestId : params.projectId}
                />
            )}

            {filesUser?.length > 0 && viewFileList === 'table' && (
                <FileTableList
                    handleClick={handleClick}
                    isReadOnly={isReadOnly}
                    files={filesUser}
                    idEntity={isRequestPage ? params.requestId : params.projectId}
                />
            )}
        </>
    )
}
